import type { ItemCacheIdentity } from "@memorang/features/src/qa-search/types";

type IdentityValue = string | number | null | undefined;

type ItemCacheIdentityInput = {
	organizationId: IdentityValue;
	projectId: IdentityValue;
	appId: IdentityValue;
	examId: IdentityValue;
	itemId: IdentityValue;
	itemVersion: IdentityValue;
	locale: IdentityValue;
};

const normalizeIdentityValue = (value: IdentityValue): string | undefined => {
	if (value == null) {
		return undefined;
	}
	const normalized = String(value).trim();
	return normalized || undefined;
};

export const buildItemCacheIdentity = ({
	organizationId,
	projectId,
	appId,
	examId,
	itemId,
	itemVersion,
	locale,
}: ItemCacheIdentityInput): ItemCacheIdentity | null => {
	const normalizedOrganizationId = normalizeIdentityValue(organizationId);
	const normalizedProjectId = normalizeIdentityValue(projectId);
	const normalizedAppId = normalizeIdentityValue(appId);
	const normalizedExamId = normalizeIdentityValue(examId);
	const normalizedItemId = normalizeIdentityValue(itemId);
	const normalizedItemVersion = normalizeIdentityValue(itemVersion);
	const normalizedLocale = normalizeIdentityValue(locale);

	if (
		!(
			normalizedOrganizationId &&
			normalizedProjectId &&
			normalizedAppId &&
			normalizedExamId &&
			normalizedItemId &&
			normalizedItemVersion &&
			normalizedLocale
		)
	) {
		return null;
	}

	return {
		organizationId: normalizedOrganizationId,
		projectId: normalizedProjectId,
		appId: normalizedAppId,
		examId: normalizedExamId,
		itemId: normalizedItemId,
		itemVersion: normalizedItemVersion,
		locale: normalizedLocale,
	};
};
